import { ButtonHTMLAttributes } from 'react'
import { DisplayProps, MarginProps, PositionProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import PDSText, { TextSize } from 'designSystem/components/PDSText/PDSText'
import INTERNALxButton from 'designSystem/components/internal/elements/INTERNALxButton'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

type INTERNAL_StateButtonSize = 'sm' | 'md' | 'lg'

type BaseProps = ButtonHTMLAttributes<HTMLButtonElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  isActive?: boolean
  size?: INTERNAL_StateButtonSize
  testId?: string
  text?: string
} & BaseProps

export default function INTERNALxGroupButton({
  isActive = false,
  name,
  size = 'sm',
  testId,
  text,
  ...props
}: Props) {
  const selectState = isActive ? 'active' : 'inactive'
  const buttonColor = isActive ? COLOR.neutral300 : 'none'
  const textColor = isActive ? COLOR.textSecondary : COLOR.textTertiary

  return (
    <INTERNALxButton
      {...props}
      alignItems="center"
      backgroundColor={buttonColor}
      borderRadius={SIZE.s4}
      className={`button group ${selectState}`}
      display="flex"
      justifyContent="center"
      padding={`${SIZE.s4} ${SIZE.s8}`}
      testId={testId}
      whiteSpace="nowrap"
    >
      <PDSText
        className="button-text"
        color={textColor}
        display="block"
        size={INTERNAL_BUTTON_SIZE[size].textSize}
        weight="semibold"
      >
        {text}
      </PDSText>
    </INTERNALxButton>
  )
}

type ButtonSizeStyles = {
  textSize: TextSize
  width?: string
}
const INTERNAL_BUTTON_SIZE: { [key: string]: ButtonSizeStyles } = {
  sm: {
    textSize: 'sm',
  },
  md: {
    textSize: 'md',
  },
  lg: {
    textSize: 'lg',
  },
}
